import Rails from "@rails/ujs"
import Choices from "choices.js"
Rails.start();

var element = document.querySelector("#stream_input_last_resort_internal_bus_output_id");
if (element) {
  new Choices(element);
}
document.querySelectorAll(".output-select-choicesjs").forEach(e => {
  new Choices(e);
});
document.addEventListener('cocoon:after-insert', function (e) {
  const added = e.detail[2];
  const newSelector = added.querySelector(".output-select-choicesjs");
  if (newSelector) {
    new Choices(newSelector);
  }

  console.log(added);
});

import "../components"
import "../controllers"
import "../utils/cocoon"

